import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import ReactFileReader from 'react-file-reader';
import { injectIntl } from 'react-intl';

class FileReader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFileSizeError: false,
    };
  }

  validateFileSize = (files) => {
    const fileSizeLimit = 209715200; // 200 MBs;
    const list = files && files.fileList;
    if (!list || list.length === 0) {
      this.setState({ showFileSizeError: false });
      return;
    }
    for (let i = 0; i < list.length; i++) {
      if (list[i].size >= fileSizeLimit) {
        this.setState({ showFileSizeError: true });
        return;
      }
    }
    this.props.handleFiles(files);
    this.setState({ showFileSizeError: false });
  };

  generateFileTypes = () => {
    const types = Array.isArray(this.props.fileType) ? this.props.fileType : [this.props.fileType];
    return types.map((t) => (t === 'document' ? 'application/pdf' : `${t}/*`));
  };

  render() {
    const intl = this.props.intl;
    return (
      <div>
        {this.state.showFileSizeError && (
          <div className="alert alert-danger">{intl.formatMessage({ id: 'fileSizeError' })}</div>
        )}
        <ReactFileReader
          base64
          multipleFiles={this.props.multipleFiles === true}
          handleFiles={this.validateFileSize}
          fileTypes={this.generateFileTypes()}
        >
          <button className="button">
            <span className="upload-plus">+ </span>
            <span className="upload-text">
              {this.props.buttonLabel || intl.formatMessage({ id: this.props.title.toLowerCase() })}
            </span>
          </button>
        </ReactFileReader>
      </div>
    );
  }
}

FileReader.propTypes = {
  fileType: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  handleFiles: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  intl: PropTypes.shape({}).isRequired,
  multipleFiles: PropTypes.bool,
};

export default injectIntl(FileReader);
